/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionGenerationInputs } from './InformationExtractionGenerationInputs';
import {
  InformationExtractionGenerationInputsFromJSON,
  InformationExtractionGenerationInputsFromJSONTyped,
  InformationExtractionGenerationInputsToJSON,
} from './InformationExtractionGenerationInputs';

/**
 *
 * @export
 * @interface PaginatedInformationExtractionGenerationInputsList
 */
export interface PaginatedInformationExtractionGenerationInputsList {
  /**
   *
   * @type {number}
   * @memberof PaginatedInformationExtractionGenerationInputsList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedInformationExtractionGenerationInputsList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedInformationExtractionGenerationInputsList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<InformationExtractionGenerationInputs>}
   * @memberof PaginatedInformationExtractionGenerationInputsList
   */
  results: Array<InformationExtractionGenerationInputs>;
}

/**
 * Check if a given object implements the PaginatedInformationExtractionGenerationInputsList interface.
 */
export function instanceOfPaginatedInformationExtractionGenerationInputsList(
  value: object,
): value is PaginatedInformationExtractionGenerationInputsList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedInformationExtractionGenerationInputsListFromJSON(
  json: any,
): PaginatedInformationExtractionGenerationInputsList {
  return PaginatedInformationExtractionGenerationInputsListFromJSONTyped(json, false);
}

export function PaginatedInformationExtractionGenerationInputsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedInformationExtractionGenerationInputsList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(InformationExtractionGenerationInputsFromJSON),
  };
}

export function PaginatedInformationExtractionGenerationInputsListToJSON(
  value?: PaginatedInformationExtractionGenerationInputsList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(InformationExtractionGenerationInputsToJSON),
  };
}
